import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsComponent } from './reports.component';
import { ReportDownloadComponent } from '../shared/report-download/report-download.component';
import { ReportDownloadService } from '../shared/report-download/report-download.service';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [ReportsComponent, ReportDownloadComponent],
  providers: [ReportDownloadService]
})
export class ReportsModule {}
